module.exports = __webpack_public_path__ + "public/img/menganalisa produk asuransi untuk menjadi tenaga pemasaran asuransi-2.1ae77d79.png";